import { getAuth } from 'firebase/auth'
import { initializeApp } from 'firebase/app'
import { getFirestore } from 'firebase/firestore'

// const firebaseConfig = {
//   apiKey: 'AIzaSyDdLtjXRwd8H_qUEOrau4J_S9p_g3ICvHA',
//   authDomain: 'product-faq.firebaseapp.com',
//   projectId: 'product-faq',
//   storageBucket: 'product-faq.appspot.com',
//   messagingSenderId: '860229968235',
//   appId: '1:860229968235:web:c4c050ac8e511e02d62c2e',
//   measurementId: 'G-VGKGSVPP13',
// }

const firebaseConfig = {
    apiKey: process.env.REACT_APP_GOOGLE_API_KEY,
    authDomain: process.env.REACT_APP_GOOGLE_AUTH_DOMAIN,
    databaseURL: process.env.REACT_APP_GOOGLE_DB_URL,
    projectId: process.env.REACT_APP_GOOGLE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_GOOGLE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_GOOGLE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_GOOGLE_APP_ID,
    measurementId: process.env.REACT_APP_GOOGLE_MEASUREMENT_ID
};



const app = initializeApp(firebaseConfig)
const db = getFirestore(app)
const auth = getAuth(app)

export default db
export { auth }
